import { message, Row } from 'antd';
import { useEffect } from 'react';

import { Form, FormItem, FormItemInput } from '../../../../components/index';
import { useGetCompaniesQuery } from '../../../../services/companyApi';
import { PortType } from '../../../../types';
import { formatPortToSave } from '../../../../utils/formatters';
import { isNullOrUndefined } from '../../../../utils/utils';
import { FormItemsWrapper } from '../company/companyForm';
import { RegisterHeaderForm } from '../registerHeaderForm';
import {
  useCreatePortMutation,
  useDeletePortMutation,
  useUpdatePortMutation,
} from '../../../../services/portApi';

type PortFormProps = {
  name: string;
  onClose: () => void;
  selectedPort: any;
  onSavePort: () => void;
  setQueryPage: (page: number) => void;
};
export function PortForm(props: PortFormProps) {
  const { name, onClose, selectedPort, onSavePort, setQueryPage } = props;
  const [
    createPort,
    { isSuccess: isSuccessSavePort, isError: isErrorSavePort },
  ] = useCreatePortMutation();
  const [
    updatePort,
    { isSuccess: isSuccessUpdatePort, isError: isErrorUpdatePort },
  ] = useUpdatePortMutation();
  const [
    deletePort,
    { isSuccess: isSuccessDeletePort, isError: isErrorDeletePort },
  ] = useDeletePortMutation();

  function validatePortlot(port: PortType): boolean {
    if (isNullOrUndefined(port.name)) {
      message.error('É necessario informar pelo menos o nome.');
      return false;
    }
    return true;
  }

  async function handleFormSubmit(values: any) {
    if (!validatePortlot(values)) return;
    let savedPort;
    if (selectedPort) {
      savedPort = await updatePort(formatPortToSave(values));
    } else {
      savedPort = await createPort(formatPortToSave(values));
    }
    if ('data' in savedPort) {
      onSavePort();
    }
  }

  async function onDeletePort() {
    if (selectedPort && selectedPort.bi_trigram) {
      setQueryPage(1);
      await deletePort(selectedPort.bi_trigram);
    }
  }
  useEffect(() => {
    if (isSuccessSavePort || isSuccessUpdatePort) {
      message.success('Porto salvo');
      onClose();
    } else if (isErrorSavePort || isErrorUpdatePort) {
      message.error(
        'Ocorreu um erro ao salvar o Porto, se o erro persistir entre em contato com o suporte'
      );
    }
  }, [
    isSuccessSavePort,
    isErrorSavePort,
    isSuccessUpdatePort,
    isErrorUpdatePort,
  ]);

  useEffect(() => {
    if (isSuccessDeletePort) {
      message.success('Porto excluído');
      onClose();
      onSavePort();
    } else if (isErrorDeletePort) {
      message.error(
        'Ocorreu um erro ao excluir o porto, se o erro persistir entre em contato com o suporte'
      );
    }
  }, [isSuccessDeletePort, isErrorDeletePort]);
  return (
    <Form
      name={name}
      layout="vertical"
      onFinish={handleFormSubmit}
      initialValues={selectedPort || {}}
    >
      <RegisterHeaderForm
        onClose={onClose}
        formName={name}
        allowDelete={!!selectedPort}
        onDelete={onDeletePort}
      >
        {selectedPort ? (
          <div className="title">{selectedPort.name}</div>
        ) : (
          <div className="title">Novo Porto</div>
        )}
      </RegisterHeaderForm>
      <FormItemsWrapper>
        <Row>
          <FormItem noStyle name="id" />
          <FormItemInput
            label="Nome"
            name="name"
            required
            placeholder="Nome do Porto"
          />
        </Row>
        <Row gutter={16}>
          <FormItemInput
            colSpan={12}
            label="Trigrama"
            name="trigram"
            required
            placeholder="NLA"
            maxLength={3}
          />
          <FormItemInput
            colSpan={12}
            label="Bi Trigrama"
            name="bi_trigram"
            required
            placeholder="ZMNLA"
            maxLength={5}
          />
        </Row>
        <Row gutter={16}>
          <FormItemInput
            colSpan={12}
            label="COD. País"
            name="country_code"
            required
            placeholder="BRA"
            maxLength={3}
          />
          <FormItemInput
            colSpan={12}
            label="País"
            name="country_name"
            required
            placeholder="Brasil"
          />
        </Row>
      </FormItemsWrapper>
    </Form>
  );
}
